let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBSzi")).then(() => parcelRequire('9bIwZ'));